const toast = {}
toast.install = function (Vue, options) {
  Vue.prototype.$toast = function (message, type = 1, time_out = 5000, extend_time_out = 100, close_button = false, label = undefined, param = undefined) {
    message = label !== undefined ? options.language.capitalize(options.language.i18n, options.language.i18n.tc(message, param, { [label]: param })) : options.language.capitalize(options.language.i18n, message)
    window.toastr.options = {
      'closeButton': close_button,
      'debug': false,
      'newestOnTop': false,
      'progressBar': false,
      'positionClass': 'toast-bottom-right',
      'preventDuplicates': false,
      'onclick': null,
      'showDuration': '300',
      'hideDuration': '100',
      'timeOut': time_out,
      'extendedTimeOut': extend_time_out,
      'showEasing': 'swing',
      'hideEasing': 'linear',
      'showMethod': 'fadeIn',
      'hideMethod': 'fadeOut'
    }

    switch (type) {
      case 1:
        window.toastr.success(message)
        break
      case 2:
        window.toastr.info(message)
        break
      case 3:
        window.toastr.warning(message)
        break
      case 4:
        window.toastr.error(message)
        break
      default:
        window.toastr.success(message)
        break
    }
  }
}

export default toast



// WEBPACK FOOTER //
// app/javascript/src/plugins/toast/configToastr.js